import * as React from 'react';

import classNames from 'classnames';
// eslint-disable-next-line import/no-unresolved
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { IPicProps, IPicState } from './types';

import * as s from './Pic.scss';

export class Pic extends React.PureComponent<IPicProps, IPicState> {

	state: IPicState = {
		isShowError: false,
	};
	image: HTMLImageElement;

	onErrorImage = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
		this.setState({
			isShowError: true,
		});
	};

	render() {
		const {
			className,
			src,
			alt,
			srcSet,
			sizes,
			title,
		} = this.props;
		const {
			isShowError,
		} = this.state;

		return (
			<LazyLoadImage
				wrapperClassName={classNames(className, s.block, { [s.blockError]: !!isShowError || !src })}
				className={s.image}
				src={src}
				alt={alt}
				srcSet={srcSet}
				sizes={sizes}
				title={title}
				onLoad={this.props.onSuccessLoad}
				onError={this.onErrorImage}
			/>
		);
	}

}
